export const media = {
    sm: (...args) => `
        @media (min-width: 576px) {
            ${args}
        }
    `,
    md: (...args) => `
        @media (min-width: 768px) {
            ${args}
        }
    `,
    lg: (...args) => `
        @media (min-width: 992px) {
            ${args}
        }
    `,
    xl: (...args) => `
        @media (min-width: 1200px) {
            ${args}
        }
    `,
};

export const scroll = {
    custom: () => `
        &::-webkit-scrollbar {
            width: 8px;
            height: 8px;
        }

        &::-webkit-scrollbar-thumb {
            background: #004167;
            border-radius: 4px;
        }

        &::-webkit-scrollbar-thumb:hover {
            background: #004167;
        }

        &::-webkit-scrollbar-thumb:active {
            background-color: #004167;
        }

        &::-webkit-scrollbar-track {
            background: transparent;
            border-radius: 4px;
        }

        &::-webkit-scrollbar-track:hover,
        &::-webkit-scrollbar-track:active {
            background: transparent;
        }
    `,
};
